module.exports = __webpack_public_path__ + "static/media/05_Share-With-World-Animated.e8da4759.gif";